import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Paper,
  Typography,
  styled,
  Stack,
} from "@mui/material";
import { color } from "framer-motion";
import booksJson from "../../utils/BookPublished.json";
import chaptersJson from "../../utils/ChapterPublished.json";

const typedBooksJson = booksJson as BooksJsonType;
const typedChaptersJson = chaptersJson as ChapterJsonType;

type BooksJsonType = {
  "Sr. No": number;
  "ISBN No": string;
  "Author/s": string;
  "Title": string;
  "Name of Publisher": string;
  "Place of Publication": string;
  "Pages": number;
  "Year": number;
  "Department": string;
}[];

type ChapterJsonType = {
  SrNo: number;
  ISBNNo: string;
  Authors: string;
  Title: string;
  Publisher: string;
  PlaceOfPublication: string;
  Pages: number;
  Year: number;
  Department: string;
}[];

type Book = {
  srNo: number;
  isbnNo: string;
  authors: string;
  title: string;
  nameOfPublisher: string;
  placeOfPublication: string;
  pages: number;
  year: number;
  department: string;
};

type Chapter = {
  srNo: number;
  isbnNo: string;
  authors: string;
  chapterName: string;
  bookTitle: string;
  nameOfPublisher: string;
  placeOfPublication: string;
  pages: number;
  year: number;
  department: string;
};

const booksData: Book[] = typedBooksJson.map((book) => ({
  srNo: book["Sr. No"],
  isbnNo: book["ISBN No"],
  authors: book["Author/s"],
  title: book["Title"],
  nameOfPublisher: book["Name of Publisher"],
  placeOfPublication: book["Place of Publication"],
  pages: book["Pages"],
  year: book["Year"],
  department: book["Department"],
}));

const chaptersData: Chapter[] = typedChaptersJson.map((chapter) => ({
  srNo: chapter.SrNo,
  isbnNo: chapter.ISBNNo,
  authors: chapter.Authors,
  chapterName: chapter.Title,
  bookTitle: chapter.Title,
  nameOfPublisher: chapter.Publisher,
  placeOfPublication: chapter.PlaceOfPublication,
  pages: chapter.Pages,
  year: chapter.Year,
  department: chapter.Department,
}));

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 14,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
}));

function ChapterBookPublished() {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography
          variant="h6"
          sx={{
            p: 1,
            backgroundColor: "primary.main",
            color: "white",
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Books Published
        </Typography>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Sr. No</TableCell>
                <TableCell align="center">ISBN No</TableCell>
                <TableCell align="center">Author/s</TableCell>
                <TableCell align="center">Title</TableCell>
                <TableCell align="center">Name of Publisher</TableCell>
                <TableCell align="center">Place of Publication</TableCell>
                <TableCell align="center">Pages</TableCell>
                <TableCell align="center">Year</TableCell>
                <TableCell align="center">Department</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {booksData?.length > 0 ? (
                booksData.map((book) => (
                  <TableRow key={book.srNo}>
                    <TableCell align="center">{book.srNo}</TableCell>
                    <TableCell align="center">{book.isbnNo}</TableCell>
                    <TableCell align="center">{book.authors}</TableCell>
                    <TableCell align="center">{book.title}</TableCell>
                    <TableCell align="center">{book.nameOfPublisher}</TableCell>
                    <TableCell align="center">
                      {book.placeOfPublication}
                    </TableCell>
                    <TableCell align="center">{book.pages}</TableCell>
                    <TableCell align="center">{book.year}</TableCell>
                    <TableCell align="center">{book.department}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    colSpan={9}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {"No data Found!"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography
          variant="h6"
          sx={{
            p: 1,
            backgroundColor: "primary.main",
            color: "white",
            mt: 4,
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Chapters Published
        </Typography>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Sr. No</TableCell>
                <TableCell align="center">ISBN No</TableCell>
                <TableCell align="center">Author/s</TableCell>
                <TableCell align="center">Chapter Name</TableCell>
                <TableCell align="center">Book Title</TableCell>
                <TableCell align="center">Name of Publisher</TableCell>
                <TableCell align="center">Place of Publication</TableCell>
                <TableCell align="center">Pages</TableCell>
                <TableCell align="center">Year</TableCell>
                <TableCell align="center">Department</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chaptersData?.length > 0 ? (
                chaptersData.map((chapter) => (
                  <TableRow key={chapter.srNo}>
                    <TableCell align="center">{chapter.srNo}</TableCell>
                    <TableCell align="center">{chapter.isbnNo}</TableCell>
                    <TableCell align="center">{chapter.authors}</TableCell>
                    <TableCell align="center">{chapter.chapterName}</TableCell>
                    <TableCell align="center">{chapter.bookTitle}</TableCell>
                    <TableCell align="center">
                      {chapter.nameOfPublisher}
                    </TableCell>
                    <TableCell align="center">
                      {chapter.placeOfPublication}
                    </TableCell>
                    <TableCell align="center">{chapter.pages}</TableCell>
                    <TableCell align="center">{chapter.year}</TableCell>
                    <TableCell align="center">{chapter.department}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    colSpan={10}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {"No data Found!"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

export default ChapterBookPublished;
